export class Card {
  id?: string;
  card_no?: string;
  card_batch_id?: number;
  store_id?: string;
  channel_id?: string;
  card_type_pid?: string;
  flg_blk_lst?: any;
  date_blk_lst?: string;
  time_blk_lst?: string;
  reason_id?: string;
  date_start?: string;
  date_end?: string;
  card_def_id?: number;
  storeDescription?: string;
  store?: string;
  channelCode?: string;
  channelDescription?: string;
  cardTypeDescription?: string;
  reasonDescription?: string;
  vCustomerId?: number;
  customerHostId?: number;
  customerState?: number;
  customerDescription?: string;
  isCompany?: string;
  pdf_link?: string;
  flg_oblivion?: any;
}


export class PointTransferModel {
  customerFrom: number;
  customerTo: number;
  accumulatorId: number;
  value: number;
}

export class  CardDomiciliationModel {
  store_from: number;
  store_to: number;
  card_id: number;
}



// WEBPACK FOOTER //
// ./src/app/models/loyalty-card.model.ts